import { render, staticRenderFns } from "./RmpForgotPassword.vue?vue&type=template&id=743c8804"
import script from "./RmpForgotPassword.vue?vue&type=script&setup=true&lang=ts"
export * from "./RmpForgotPassword.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports